<div class="card">
    <div class="card-body kpi-card">
        <p class="card-value">
            <ng-container *ngIf="preview">- €/mois</ng-container>
            <ng-container *ngIf="!preview">
                <span class="fs-7">Utilisez LyBox sur PC pour calculer votre imposition</span>
            </ng-container>
        </p>
    </div>
</div>
